import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { Message } from 'element-ui';
import request from '@/utils/request';
export { request };
function saveBlob(response, filename) {
  var contentType = response.type || '';
  if (contentType.includes('application/json')) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        try {
          var errorData = JSON.parse(reader.result);
          Message.error(errorData.message || '下载失败');
          reject(errorData);
        } catch (error) {
          Message.error('下载失败');
          reject(error);
        }
      };
      reader.readAsText(response);
    });
  }
  var link = document.createElement('a');
  var blob = new Blob([response], {
    type: 'application/octet-stream'
  });
  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
  return response;
}
export function get(url, params, options) {
  return request(_objectSpread({
    url: url,
    method: 'get',
    params: params
  }, options));
}
export function post(url, data, options) {
  return request(_objectSpread({
    url: url,
    method: 'post',
    data: data
  }, options));
}
export function put(url, data, options) {
  return request(_objectSpread({
    url: url,
    method: 'put',
    data: data
  }, options));
}
export function patch(url, data, options) {
  return request(_objectSpread({
    url: url,
    method: 'patch',
    data: data
  }, options));
}
export function destroy(url, params, options) {
  return request(_objectSpread({
    url: url,
    method: 'delete',
    params: params
  }, options));
}
export function del(url, data, options) {
  return request(_objectSpread({
    url: url,
    method: 'delete',
    data: data
  }, options));
}
export function preview(url, params, options) {
  return request(_objectSpread({
    url: url,
    method: 'post',
    params: params,
    responseType: 'blob'
  }, options));
}
export function download(url, params, filename) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180000;
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return request(_objectSpread({
    url: url,
    method: 'post',
    params: params,
    responseType: 'blob',
    timeout: timeout
  }, options)).then(function (response) {
    return saveBlob(response, filename);
  });
}
export function exportFile(url, data, filename) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 180000;
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return request(_objectSpread({
    url: url,
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: timeout
  }, options)).then(function (response) {
    return saveBlob(response, filename);
  });
}
export function upload(url, file) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var uploadData = file instanceof File ? file : new Blob([file], {
    type: 'application/octet-stream'
  });
  return request(_objectSpread({
    url: url,
    method: 'put',
    data: uploadData,
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    transformRequest: [function (data) {
      return data;
    }],
    noAuth: true
  }, options));
}
export default {
  get: get,
  post: post,
  put: put,
  patch: patch,
  destroy: destroy,
  del: del,
  preview: preview,
  download: download,
  exportFile: exportFile,
  upload: upload,
  request: request
};